/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import styled from "styled-components";
import parse from "html-react-parser";
import { Add, Remove } from "@material-ui/icons";
import { Icons } from "../../components";
import { getContent } from "../../services";
import DetailPbdj from "./DetailPbdj";
import { Typography } from "@material-ui/core";

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledItemList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledTitle = styled.div`
  margin-left: 1rem;
  margin-bottom: 2rem;
`;

const StyledItem = styled.div<{ active: boolean }>`
  width: 100%;
  padding: 1rem 2rem;
  border-top: 1px solid #bbbbbb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  & div p {
    color: ${({ active, theme }) =>
      active ? theme.colors.main : theme.colors.text.main};
  }
  &:hover div p {
    color: #e3232a;
  }
`;

const StyledItemLeft = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const StyledCard = styled.div`
  text-decoration: none;
  display: block;
  width: 100%;
`;

const StyledItemCard = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  border: 1px solid #e0e0e0;
  margin-bottom: 1rem;
  cursor: pointer;

  &:hover {
    background-color: #eaeaea;
  }
`;

const StyledDescCard = styled.div`
  width: 70%;
  &:hover p:first-child {
    color: #e3232a;
  }
`;

const StyledAddressCard = styled.div`
  flex: 1;
  text-align: right;
`;

const StyledNextCard = styled.div`
  padding-left: 1rem;
`;

const Pbdj = ({ isId }: any) => {
  const [activeState, setActiveState] = useState("");
  const [dataPbdjState, setDataPbdjState] = useState<any>(null);
  const [detailPbdjState, setDetailPbdjState] = useState(false);
  const [detailDataPbdjState, setDetailDataPbdjState] = useState({
    id: "",
    title_id: "",
    title_en: "",
    sub_title_id: "",
    sub_title_en: "",
    place: "",
    contract: "",
    content_id: "",
    content_en: "",
  });

  const getData = async () => {
    try {
      const res: any = await getContent(8, 10, 1);
      const formatData: any = res.data.rows.reduce((acc: any, d: any) => {
        const found = acc.find((a: any) =>
          isId ? a.title_id : a.title_en === isId ? d.title_id : d.title_en
        );
        const value = {
          id: d.id,
          sub_title_id: d.sub_title_id,
          sub_title_en: d.sub_title_en,
          place: d.place,
          contract: d.contract,
          content_id: d.content_id,
          content_en: d.content_en,
        };
        if (!found) {
          acc.push({
            title_id: d.title_id,
            title_en: d.title_en,
            data: [value],
          });
        } else {
          found.data.push(value);
        }
        return acc;
      }, []);
      setDataPbdjState(formatData);
    } catch (err) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {detailPbdjState ? (
        <DetailPbdj
          isId={isId}
          dataPbdj={detailDataPbdjState}
          onHandleBack={() => setDetailPbdjState(false)}
        />
      ) : (
        <StyledContent>
          <StyledItemList>
            <StyledTitle>
              <Typography color="primary" variant="h4" gutterBottom>
                {isId
                  ? "Pengadaan Barang dan Jasa"
                  : "Procurement of Goods and Services"}
              </Typography>
            </StyledTitle>
            {dataPbdjState?.length === 0 && (
              <Typography color="textSecondary">
                {isId
                  ? "Tidak ada Pengadaan Barang dan Jasa"
                  : "No Procurement of Goods and Services"}
              </Typography>
            )}
            {dataPbdjState?.map(({ title_id, title_en, data }: any) => {
              const title = isId ? title_id : title_en;
              return (
                <React.Fragment key={title_id}>
                  <StyledItem
                    onClick={() =>
                      setActiveState(title === activeState ? "" : title)
                    }
                    active={title === activeState}
                  >
                    <StyledItemLeft>
                      {title === activeState ? (
                        <Remove style={{ color: "#424244" }} />
                      ) : (
                        <Add style={{ color: "#424244" }} />
                      )}
                      <Typography
                        variant="h6"
                        color="textPrimary"
                        style={{ marginLeft: "1rem" }}
                      >
                        {title}
                      </Typography>
                    </StyledItemLeft>
                    <div style={{ display: "flex" }}>
                      <Typography color="textPrimary">{data.length}</Typography>
                      <Typography style={{ marginLeft: ".5rem" }}>
                        {isId ? "Pengadaan" : "Procurement"}
                      </Typography>
                    </div>
                  </StyledItem>
                  {title === activeState &&
                    data.map((r: any, i: any) => (
                      <StyledCard
                        key={i}
                        onClick={() => {
                          setDetailDataPbdjState(r);
                          setDetailPbdjState(true);
                        }}
                      >
                        <StyledItemCard>
                          <StyledDescCard>
                            <Typography
                              color="textPrimary"
                              gutterBottom
                              style={{ fontWeight: 800 }}
                            >
                              {isId ? r.sub_title_id : r.sub_title_en}
                            </Typography>
                            <div
															id="content"
															style={{ color: 'rgba(0, 0, 0, 0.54)' }}
														>
															{parse(
																isId
																	? r.content_id.substring(0, 200)
																	: r.content_en.substring(0, 200)
															)}
														</div>
                          </StyledDescCard>
                          <StyledAddressCard>
                            <Typography color="textPrimary">
                              {r.place}
                            </Typography>
                          </StyledAddressCard>
                          <StyledNextCard>
                            <Icons.IconNext
                              width={20}
                              height={20}
                              fill="white"
                              secondFill="red"
                            />
                          </StyledNextCard>
                        </StyledItemCard>
                      </StyledCard>
                    ))}
                </React.Fragment>
              );
            })}
          </StyledItemList>
        </StyledContent>
      )}
    </>
  );
};

export default Pbdj;
